var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgentEmptyAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2499_105676)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.07393,
    y: 0.573925,
    width: 16.8521,
    height: 16.8521,
    rx: 8.42607,
    stroke: "#2F3746",
    strokeWidth: 1.14785
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5262,
    y: 13.0257,
    width: 4.34785,
    height: 4.34785,
    rx: 2.17393,
    fill: "#38CB89"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5262,
    y: 13.0257,
    width: 4.34785,
    height: 4.34785,
    rx: 2.17393,
    stroke: "#2F3746",
    strokeWidth: 1.14785
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2499_105676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2499_105676"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentEmptyAvailable);
export default __webpack_public_path__ + "static/media/agent-empty-available.c69be7b20ee25d3a2e66dd92b1fe3588.svg";
export { ForwardRef as ReactComponent };